import styled from 'styled-components/macro';

import { IconLink } from 'components/blueprint';

export const InlineIconLink = styled(IconLink)`
  && {
    display: inline-flex;
  }
`;
